// Angular
import { Injectable } from '@angular/core';

// Rxjs
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class MsgService {
    constructor() {

    }

    private messageSource = new BehaviorSubject<any>('');

    changeMessage(message: string) {
        this.messageSource.next(message);
    }

    getMessageSource() {
        return this.messageSource.asObservable();
    }

}
